import { combineReducers } from 'redux';

import signup                from './auth/signup';
import login                 from './auth/login';
import logout                from './auth/logout';
import verifyotp             from './auth/verifyotp';
import resendotp             from './auth/resendotp';
import reviewmembership      from './auth/reviewmembership';
import lastpost              from './feed/lastpost';
import listfeed              from './feed/listfeed';
import editpost              from './feed/editpost';
import activetab             from './user/activetab';
import listuserfriend        from './user/listuserfriend';
import frienddetail          from './user/frienddetail';
import listusergallery       from './user/listusergallery';
import userprofiledetail     from './user/userprofiledetail';
import countrylist           from './common/countrylist';
import statelist             from './common/statelist';
import citylist              from './common/citylist';
import idlist                from './common/idlist';
import professionlist        from './common/professionlist';
import categorylist          from './common/categorylist';
import dropdownuserfriend    from './user/dropdownuserfriend';
import fetchlikelist         from './reaction/fetchlikelist';
import updatelikelist        from './reaction/updatelikelist';
import postdetail            from './post/postdetail';
import fetchcommentlist      from './reaction/fetchcommentlist';
import updatecommentlist     from './reaction/updatecommentlist';
import updatecommentlikelist from './reaction/updatecommentlikelist';
import fetchlikecommentlist  from "./reaction/fetchlikecommentlist";
import imagecarousal         from "./feed/imagecarousal";
import imagelist             from "./feed/imagelist";
import postfriend            from "./feed/postfriend";
import deletepost            from "./feed/deletepost"
import listtimeline          from "./user/listtimeline";
import mediadetails          from "./media/mediadetails";
import deletefeed            from "./user/deletefeed";
import currentlanguage       from "./user/currentlanguage";
import albumdetails          from "./media/albumdetails";
import createalbum           from "./media/createalbum";
import promotiontype         from "./promotion/promotiontype";
import calculatereach        from "./promotion/calculatereach";
import hobbylist             from "./common/hobbylist";
import preview               from "./promotion/preview";
import savepromotion         from "./promotion/savepromotion";
import listpromotion         from "./promotion/listpromotion";
import updatepromotion       from "./promotion/updatepromotion";
import promotiondetail       from "./promotion/promotiondetail";
import promotionlimit        from "./promotion/promotionlimit";
import friendrequest         from "./friendrequest/friendrequest";
import requestrespond        from "./friendrequest/requestrespond";
import unfriendrequest       from "./friendrequest/unfriendrequest";
import requestcancel         from "./friendrequest/requestcancel";
import searchfriend         from "./friendrequest/searchfriend";
import countnotification     from "./notification/countnotification";
import notificationlist      from "./notification/notificationlist";
import readnotification      from "./notification/readnotification";
import friendnotificationlist from "./notification/friendnotificationlist";
import chatuserlist          from "./chat/chatuserlist";
import readchat              from "./chat/readchat";
import createchat            from "./chat/createchat";
import removechat            from "./chat/removechat";
import chatsearch            from "./chat/chatsearch";
import changeprofilepic      from "./user/changeprofilepic";
import newpoll               from "./poll/newpoll";
import castvote              from "./poll/castvote";
import detailpoll            from "./poll/detailpoll";
import wallet                from "./evc/wallet";

import { USER_LOGGED_OUT } from '../actions/constants';

const allReducers = {
  signup,
  login,
  lastpost,
  listfeed,
  logout,
  activetab,
  listuserfriend,
  frienddetail,
  listusergallery,
  userprofiledetail,
  countrylist,
  statelist,
  citylist,
  professionlist,
  idlist,
  categorylist,
  dropdownuserfriend,
  fetchlikelist,
  updatelikelist,
  postdetail,
  fetchcommentlist,
  updatecommentlist,
  updatecommentlikelist,
  fetchlikecommentlist,
  imagecarousal,
  imagelist,
  listtimeline,
  mediadetails,
  deletefeed,
  albumdetails,
  createalbum,
  promotiontype,
  calculatereach,
  hobbylist,
  preview,
  savepromotion,
  listpromotion,
  updatepromotion,
  promotiondetail,
  friendrequest,
  requestrespond,
  unfriendrequest,
  requestcancel,
  promotionlimit,
  countnotification,
  currentlanguage,
  chatuserlist,
  readchat,
  postfriend,
  createchat,
  removechat,
  chatsearch,
  verifyotp,
  resendotp,
  reviewmembership,
  notificationlist,
  readnotification,
  deletepost,
  friendnotificationlist,
  searchfriend,
  editpost,
  changeprofilepic,
  newpoll,
  castvote,
  detailpoll,
  wallet
};

const appReducer = combineReducers(allReducers);

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGGED_OUT') {
    Object.keys(allReducers).map(el => {
      state[el] = undefined;
      return false;
    });
  }
  return appReducer(state, action);
};

export default rootReducer;
